/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompropertyrulesets3Inputs */

const en_entity_custompropertyrulesets3 = /** @type {(inputs: Entity_Custompropertyrulesets3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property Rule Sets`)
};

const de_entity_custompropertyrulesets3 = /** @type {(inputs: Entity_Custompropertyrulesets3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property Regeln`)
};

/**
* | output |
* | --- |
* | "Custom Property Rule Sets" |
*
* @param {Entity_Custompropertyrulesets3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompropertyrulesets3 = /** @type {((inputs?: Entity_Custompropertyrulesets3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompropertyrulesets3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompropertyrulesets3(inputs)
	return de_entity_custompropertyrulesets3(inputs)
});
export { entity_custompropertyrulesets3 as "entity_customPropertyRuleSets" }